module.exports = __webpack_public_path__ + "img/dinkenclave-6.fd449d85.jpeg";